const SESSION_ID = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

type LogLevel = 'DEBUG' | 'INFO' | 'WARN' | 'ERROR';

interface LogContext {
  userId?: string;
  component?: string;
  action?: string;
  [key: string]: any;
}

function formatTimestamp(): string {
  const now = new Date();
  return now.toISOString();
}

function formatLog(level: LogLevel, message: string, context?: LogContext): string {
  const timestamp = formatTimestamp();
  const contextStr = context ? JSON.stringify(context) : '';
  return `[${timestamp}] [${SESSION_ID}] [${level}] ${message} ${contextStr}`;
}

export const logger = {
  debug: (message: string, context?: LogContext) => {
    console.debug(formatLog('DEBUG', message, context));
  },

  info: (message: string, context?: LogContext) => {
    console.info(formatLog('INFO', message, context));
  },

  warn: (message: string, context?: LogContext) => {
    console.warn(formatLog('WARN', message, context));
  },

  error: (message: string, error?: Error | unknown, context?: LogContext) => {
    const errorContext = {
      ...context,
      error: error instanceof Error ? {
        name: error.name,
        message: error.message,
        stack: error.stack
      } : error
    };
    console.error(formatLog('ERROR', message, errorContext));
  },

  group: (title: string) => {
    console.group(`[${formatTimestamp()}] ${title}`);
  },

  groupEnd: () => {
    console.groupEnd();
  }
};
